// util function to get the value of a query param from url
export const getQueryParameter = (paramName, url = window.location.href, encrypted = false) => {
  const modifiedParamName = paramName.replace(/[\[\]]/g, '\\$&') // eslint-disable-line
  const regex = new RegExp(`[?&]${modifiedParamName}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  if (encrypted) return decodeURIComponent(results[2]) // eslint-disable-line
  return decodeURIComponent(results[2].replace(/\+/g, ' ')) // eslint-disable-line
}

// the util function to check the value of webview from queryParam
export const isValidWebViewScreen = () => {
  const webViewParam = getQueryParameter('web_view') || ''
  const webViewScreens = ['personal_details', 'signin_details', 'permission_centre', 'login', 'register', 'reset-password', 'account', 'delete_account', 'wallet_details']
  return webViewScreens.includes(webViewParam)
}

export const setRegErrorDesc = ({ regErrorCode, errorDescription }, isGeorgeUser) => {
  const errorCodes = ['ACCOUNT_ALREADY_EXISTS', 'IAM_REGISTER_LOGIN_REQUIRED']
  if (errorCodes.indexOf(regErrorCode) >= 0 && isGeorgeUser) {
    return errorDescription.replace(
      'logging in',
      `<a class='login-link' href='/login?request_origin=george'>logging in</a>`,
    )
  }
  if (errorCodes.indexOf(regErrorCode) >= 0) {
    return errorDescription.replace(
      'logging in',
      `<a class='login-link' href='/login'>logging in</a>`,
    )
  }
  return errorDescription
}

export const OPTED_IN_MARKETING_TITLE = `You previously gave us permission to send you marketing`
export const MARKETING_LABEL = `Yes, I want Asda and George to contact me`
export const OPTED_IN_MARKETING_LABEL = `Yes, send me marketing`
export const ACCOUNT_TNC_CONSENT_LABEL = `Our <a class="tc-link-register" href="https://www.asda.com/privacy" target="_blank">Privacy Centre</a> provides more details on marketing, how we use your information and about your Privacy rights.`
export const CHANGE_UNSUBSCRIBE_LABEL = `You can change this or unsubscribe at any time.`
export const REGISTER_TNC_CONSENT_LABEL = `Our <a class="tc-link-register" href="https://www.asda.com/privacy" target="_blank">Privacy Centre</a> provides more details on marketing, how we use your information and about your Privacy rights.  You can unsubscribe at any time.`
export const TNC_ERROR_MESSAGE = `I understand and accept the terms and conditions`
export const P13N_MARKETING_CONSENT_LABEL = 'Receive personalised content based on your preferences! Give your permission below - you can opt in or out at any time.'
export const P13N_MARKETING_LABEL = 'Yes, make my experience more personal, by using my:'
export const P13N_PERMISSION_CHANGE = 'You\'re changing your marketing permissions. We\'ll remove any personal details you opt out of. You\'ll need to update these again if you want to opt back in.'
// Baby Club String Constants
export const BTC_PERSONAL_DETAILS_INFO = `Changing your name here will update the details you use to sign in to your Asda and George accounts.`
export const BTC_SIGN_IN_DETAILS_INFO = `Changing your email address here will update the details you use to sign in to your Asda and George accounts.`
export const BTC_OFFER_PLACEHOLDER = `We'd like to send you offers, news and help tailored to you and your baby`
export const BTC_CONSENT_LABEL = `If you opt out you won’t receive anything from us.`
export const BTC_MARKETING_TERMS = `Yes I want Asda Baby Club to email me`
export const BABY_CLUB_TNC = `I agree to Asda Baby Club`
export const BTC_ABOUT_YOU_INFO = `By sharing this with us we can send offers, help and milestones just for you.`
export const BTC_MARKETING_LABEL = `Yes, I want the Asda Baby Club to email me with baby milestones, offers and news. Unsubscribe at any time.`
export const LEAVE_BTC_WARNING = `We'll delete all your Baby Club details, such as you child's due date/date of birth.`
export const LEAVE_BTC_CONSENT = `You'll keep access to any other Asda services you use, such as groceries shopping.`
export const LEAVE_BTC_CONFIRMATION = `You’ll now be taken back to the Baby Club homepage.`

// Password policy errors
export const PASSWORD_POLICY_ERROR = 'PASSWORD_POLICY_ERROR'
